import { render, staticRenderFns } from "./todo-detail-dialog.vue?vue&type=template&id=5c080cb2&scoped=true"
import script from "./todo-detail-dialog.vue?vue&type=script&lang=js"
export * from "./todo-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./todo-detail-dialog.vue?vue&type=style&index=0&id=5c080cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c080cb2",
  null
  
)

export default component.exports